import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { scenarioSlice } from 'entities/scenario';

export type TScenarioState = SliceStateFromReducer<typeof scenarioSlice>;

export const getScenario = (state: TScenarioState) => state.scenario.currentStep;
export const getScenarioContent = createSelector(getScenario, (step) => step?.content);
export const getScenarioLoading = (state: TScenarioState) => state.scenario.isLoading;
export const selectIsLoading = (state: TScenarioState) => state.scenario.isLoading;
